<template>
  <ul class="participant-list">
    <li v-for="participant in  participants" :key="participant.id">
      <router-link :to="pageLink(participant.id)">
        {{ participant.lastName }}, {{ participant.firstName }}
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  inject: ['participantData'],
  props: ['gate'],
  data() {
    return {
      gateNumber: this.gate,
      participants: {}
    }
  },
  methods: {
    pageLink(theID) {
      return '/participants/' + theID;
    }
  },
  created() {
    const filteredData = this.participantData.filter(participant => participant.gate === this.gateNumber);
    this.participants = filteredData;
  }
}
</script>